import * as React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.scss';

export class NotFound extends React.Component {
    render() {
        return (
            <div className='not-found-container'>
                <img src={require('../../../assets/no_requests.svg')} />
                404
                <Link className='a-no-decoration' to='/'>
                    Go Home
                </Link>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Shared/NotFound/NotFound.tsx